import { HistoryListProps } from "@husky-x/history-list";

export const HistoryMock: HistoryListProps  = {
	data: [
		{
			year: 1915,
			description: 'Презервативи продаються в перукарнях',
		},
		{
			year: 1929,
			description: 'Лондонська гумова компанія створює бренд Durex®',
		},
		{
			year: '1950-ті',
			description: 'Durex® запускає презервативи з лубрикантом',
		},
		{
			year: 1953,
			description: 'Durex®  - перший бренд, що використовує тестування елекронікою',
		},
		{
			year: '1960',
			description: 'Запуск презервативів анатомічної форми',
		},
		{
			year: '1970-ті',
			description: 'Реклама Durex® на екранах у багатьох країнах світу',
		},
		{
			year: '1997',
			description: 'Durex® презентує безлатексні презервативи',
		},
		{
			year: 2001,
			description: 'Запуск Pleasuremax – презервативів з крапками та ребрами',
		},
		{
			year: 2003,
			description: 'Durex® представляє лінійку лубрикантів',
		},
		{
			year: 2024,
			description: 'Durex®  - 95 років!',
		},
	]
}